function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M0 0h512v512H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M482 240.212v30.576L241.212 30h30.576L31 270.788v-30.576L271.788 481h-30.576L482 240.212zM256 497L15 256 256 15l241 241-241 241z",
  fill: "#43A047"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M421 240.198v30.604L241.198 91h30.604L92 270.802v-30.604L271.802 420h-30.604L421 240.198zM256 436L76 256 256 76l180 180-180 180z",
  fill: "#E53935"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M359 240.315v30.37L241.315 153h30.37L154 270.685v-30.37L271.685 358h-30.37L359 240.315zM256 374L138 256l118-118 118 118-118 118z",
  fill: "#FDD835"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M298 241.41v30.18L241.41 215h30.18L215 271.59v-30.18L271.59 298h-30.18L298 241.41zM256 313l-57-57 57-57 57 57-57 57z",
  fill: "#1E88E5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M427 405.286L405.286 427V85L427 106.714H85L106.714 85v342L85 405.286h342zM85 427V85h342v342H85z",
  fill: "#1E88E5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M384 362.298L362.298 384V129L384 150.702H129L150.702 129v255L129 362.298h255zM129 384V129h255v255H129z",
  fill: "#FDD835"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M340 318.323L318.323 340V172L340 193.677H172L193.677 172v168L172 318.323h168zM172 340V172h168v168H172z",
  fill: "#E53935"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M297 275.133L275.133 297v-82L297 236.867h-82L236.867 215v82L215 275.133h82zM215 297v-82h82v82h-82z",
  fill: "#43A047"
});

var SvgKaleidoscoperLogo = function SvgKaleidoscoperLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref7, _ref8, _ref9, _ref10))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKaleidoscoperLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kaleidoscoper-logo.394f9538.svg";
export { ForwardRef as ReactComponent };